import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';


const initialState = {
    status : 'idle',
    gameMode: 'drink',
    relationshipType: 'long_term',
    coupleType: 'mixed',
    blockModeSwitch: false,
    playerOne:{
      id: 'playerOne',
      name: '',
      gender :'',
      demoTruthsAnswered:0,
      demoLightDaresAnswered:0,
      demoDaresAnswered:0,
      exploreTruthsAnswered: 0,
      exploreDaresAnswered: 0,
      comfortTruthsAnswered: 0,
      comfortLightDaresAnswered: 0,
      comfortDaresAnswered: 0,
      openTruthsAnswered: 0,
      openLightDaresAnswered: 0,
      openDaresAnswered: 0,
      openKinkyDaresAnswered: 0,
      exploreShotsTaken: 0,
      comfortShotsTaken: 0,
      openShotsTaken: 0,
      demoShotsTaken: 0,
    },
    playerTwo:{
      id: 'playerTwo',
      name: '',
      gender :'',
      demoTruthsAnswered:0,
      demoLightDaresAnswered:0,
      demoDaresAnswered:0,
      exploreTruthsAnswered: 0,
      exploreDaresAnswered: 0,
      comfortTruthsAnswered: 0,
      comfortLightDaresAnswered: 0,
      comfortDaresAnswered: 0,
      openTruthsAnswered: 0,
      openLightDaresAnswered: 0,
      openDaresAnswered: 0,
      openKinkyDaresAnswered: 0,
      exploreShotsTaken: 0,
      comfortShotsTaken: 0,
      openShotsTaken: 0,
      demoShotsTaken: 0,
    },
    demoPlayerTurn: 'playerOne',
    explorePlayerTurn: 'playerOne',
    comfortPlayerTurn: 'playerOne',
    openPlayerTurn: 'playerOne',
    mindfulnessAlertShown: false,
  }
  
  export const contestantsSlice = createSlice({
    name: "contestants",
    initialState,
    reducers: {
      setGameMode: (state, action) => {
        state.gameMode = action.payload;
      },
      setRelationshipType: (state, action) => {
        state.relationshipType = action.payload;
      },
      setBlockModeSwitch: (state, action) => {
        state.blockModeSwitch = action.payload;
      },
      setMindfulnessAlertShown: (state, action) => {
        state.mindfulnessAlertShown = action.payload;
      },
      setPlayers: (state, action) =>{
        const { playerOneName, playerTwoName, playerOneGender, playerTwoGender } = action.payload;
        state.playerOne.name = playerOneName;
        state.playerOne.gender = playerOneGender;
        state.playerTwo.name = playerTwoName;
        state.playerTwo.gender = playerTwoGender;
        if (playerOneGender === 'female' && playerTwoGender === 'female') {
          state.coupleType = 'same_sex_f';
        } else if (playerOneGender === 'male' && playerTwoGender === 'male') {
          state.coupleType = 'same_sex_m';
        } else {
          state.coupleType = 'mixed';
        }
      },
      // demo game reducers

      incrementPlayerOneDemoTruthsAnswered: (state) => {
        state.playerOne.demoTruthsAnswered += 1; 
      },
      incrementPlayerOneDemoLightDaresAnswered: (state) => {
        state.playerOne.demoLightDaresAnswered += 1; 
      },
      incrementPlayerOneDemoDaresAnswered: (state) => {
        state.playerOne.demoDaresAnswered += 1; 
      },
      incrementPlayerTwoDemoTruthsAnswered: (state) => {
        state.playerTwo.demoTruthsAnswered += 1; 
      },
      incrementPlayerTwoDemoLightDaresAnswered: (state) => {
        state.playerTwo.demoLightDaresAnswered += 1; 
      },
      incrementPlayerTwoDemoDaresAnswered: (state) => {
        state.playerTwo.demoDaresAnswered += 1; 
      },
      incrementPlayerOneDemoShotsTaken: (state) => {
        state.playerOne.demoShotsTaken += 1; 
      },
      incrementPlayerTwoDemoShotsTaken: (state) => {
        state.playerTwo.demoShotsTaken += 1; 
      },
      toggleDemoPlayerTurn: (state) =>{
        state.demoPlayerTurn = state.demoPlayerTurn === 'playerOne' ? 'playerTwo' : 'playerOne'; 
      },
      // explore game reducers
      
        incrementPlayerOneExploreTruthsAnswered: (state) => {
          state.playerOne.exploreTruthsAnswered += 1; 
        },
        incrementPlayerOneExploreDaresAnswered: (state) => {
          state.playerOne.exploreDaresAnswered += 1; 
        },
        incrementPlayerTwoExploreTruthsAnswered: (state) => {
          state.playerTwo.exploreTruthsAnswered += 1; 
        },
        incrementPlayerTwoExploreDaresAnswered: (state) => {
          state.playerTwo.exploreDaresAnswered += 1; 
        },
        incrementPlayerOneExploreShotsTaken: (state) => {
          state.playerOne.exploreShotsTaken += 1; 
        },
        incrementPlayerTwoExploreShotsTaken: (state) => {
          state.playerTwo.exploreShotsTaken += 1; 
        },
        toggleExplorePlayerTurn: (state) =>{
          state.explorePlayerTurn = state.explorePlayerTurn === 'playerOne' ? 'playerTwo' : 'playerOne'; 
        },

        // comfort game reducers

        incrementPlayerOneComfortTruthsAnswered: (state) => {
          state.playerOne.comfortTruthsAnswered += 1; 
        },
        incrementPlayerOneComfortLightDaresAnswered: (state) => {
          state.playerOne.comfortLightDaresAnswered += 1; 
        },
        incrementPlayerOneComfortDaresAnswered: (state) => {
          state.playerOne.comfortDaresAnswered += 1; 
        },
        incrementPlayerTwoComfortTruthsAnswered: (state) => {
          state.playerTwo.comfortTruthsAnswered += 1; 
        },
        incrementPlayerTwoComfortLightDaresAnswered: (state) => {
          state.playerTwo.comfortLightDaresAnswered += 1; 
        },
        incrementPlayerTwoComfortDaresAnswered: (state) => {
          state.playerTwo.comfortDaresAnswered += 1; 
        },
        incrementPlayerOneComfortShotsTaken: (state) => {
          state.playerOne.comfortShotsTaken += 1; 
        },
        incrementPlayerTwoComfortShotsTaken: (state) => {
          state.playerTwo.comfortShotsTaken += 1; 
        },
        toggleComfortPlayerTurn: (state) =>{
          state.comfortPlayerTurn = state.comfortPlayerTurn === 'playerOne' ? 'playerTwo' : 'playerOne'; 
        },

        // open game reducers

        incrementPlayerOneOpenTruthsAnswered: (state) => {
          state.playerOne.openTruthsAnswered += 1; 
        },
        incrementPlayerOneOpenLightDaresAnswered: (state) => {
          state.playerOne.openLightDaresAnswered += 1; 
        },
        incrementPlayerOneOpenDaresAnswered: (state) => {
          state.playerOne.openDaresAnswered += 1; 
        },
        incrementPlayerOneOpenKinkyDaresAnswered: (state) => {
          state.playerOne.openKinkyDaresAnswered += 1; 
        },
        incrementPlayerTwoOpenTruthsAnswered: (state) => {
          state.playerTwo.openTruthsAnswered += 1; 
        },
        incrementPlayerTwoOpenLightDaresAnswered: (state) => {
          state.playerTwo.openLightDaresAnswered += 1; 
        },
        incrementPlayerTwoOpenDaresAnswered: (state) => {
          state.playerTwo.openDaresAnswered += 1; 
        },
        incrementPlayerTwoOpenKinkyDaresAnswered: (state) => {
          state.playerTwo.openKinkyDaresAnswered += 1; 
        },
        incrementPlayerOneOpenShotsTaken: (state) => {
          state.playerOne.openShotsTaken += 1; 
        },
        incrementPlayerTwoOpenShotsTaken: (state) => {
          state.playerTwo.openShotsTaken += 1; 
        },
        toggleOpenPlayerTurn: (state) =>{
          state.openPlayerTurn = state.openPlayerTurn === 'playerOne' ? 'playerTwo' : 'playerOne'; 
        },
        resetGame: (state, action) => {
          const gameType = action.payload
          if (gameType === 'explore'){
            state.playerOne.exploreTruthsAnswered = 0
            state.playerOne.exploreDaresAnswered = 0
            state.playerOne.exploreShotsTaken = 0
            state.playerTwo.exploreTruthsAnswered = 0
            state.playerTwo.exploreDaresAnswered = 0
            state.playerTwo.exploreShotsTaken = 0
          } else if (gameType === 'comfort'){
            state.playerOne.comfortTruthsAnswered = 0
            state.playerOne.comfortLightDaresAnswered = 0
            state.playerOne.comfortDaresAnswered = 0
            state.playerOne.comfortShotsTaken = 0
            state.playerTwo.comfortTruthsAnswered = 0
            state.playerTwo.comfortLightDaresAnswered = 0
            state.playerTwo.comfortDaresAnswered = 0
            state.playerTwo.comfortShotsTaken = 0
          } else if (gameType === 'demo'){
            state.playerOne.demoTruthsAnswered = 0
            state.playerOne.demoLightDaresAnswered = 0
            state.playerOne.demoDaresAnswered = 0
            state.playerOne.demoShotsTaken = 0
            state.playerTwo.demoTruthsAnswered = 0
            state.playerTwo.demoLightDaresAnswered = 0
            state.playerTwo.demoDaresAnswered = 0
            state.playerTwo.demoShotsTaken = 0
          } else{
            state.playerOne.openTruthsAnswered = 0
            state.playerOne.openLightDaresAnswered = 0
            state.playerOne.openDaresAnswered = 0
            state.playerOne.openKinkyDaresAnswered = 0
            state.playerOne.openShotsTaken = 0
            state.playerTwo.openTruthsAnswered = 0
            state.playerTwo.openLightDaresAnswered = 0
            state.playerTwo.openDaresAnswered = 0
            state.playerTwo.openKinkyDaresAnswered = 0
            state.playerTwo.openShotsTaken = 0
          }
          state.mindfulnessAlertShown = false;
        },
        setPlayerOneCounter: (state, action) => {
          state.playerOne.counter = action.payload; // Set counter for playerOne
        },
        setPlayerTwoCounter: (state, action) => {
          state.playerTwo.counter = action.payload; // Set counter for playerTwo
        },
    },
    
    // extraReducers: (builder) => {
    //   builder
    //     .addCase(getAllCountriesAsync.pending, (state) => {
    //       state.status = 'loading';
    //     })
    //     .addCase(getAllCountriesAsync.fulfilled, (state, action) => {
    //       state.status = 'idle';
    //       state.countriesArr = action.payload;
    //     });
    // }
  });
  
  export const {
    setGameMode,
    setRelationshipType,
    setBlockModeSwitch,
    setMindfulnessAlertShown,
    incrementPlayerOneDemoTruthsAnswered,
    incrementPlayerOneDemoLightDaresAnswered,
    incrementPlayerOneDemoDaresAnswered,
    incrementPlayerTwoDemoTruthsAnswered,
    incrementPlayerTwoDemoLightDaresAnswered,
    incrementPlayerTwoDemoDaresAnswered,
    incrementPlayerOneDemoShotsTaken,
    incrementPlayerTwoDemoShotsTaken,
    toggleDemoPlayerTurn,

    setPlayers,
    incrementPlayerOneExploreTruthsAnswered,
    incrementPlayerOneExploreDaresAnswered,
    incrementPlayerTwoExploreTruthsAnswered,
    incrementPlayerTwoExploreDaresAnswered,
    incrementPlayerOneExploreShotsTaken,
    incrementPlayerTwoExploreShotsTaken,
    toggleExplorePlayerTurn,


    incrementPlayerOneComfortTruthsAnswered,
    incrementPlayerOneComfortLightDaresAnswered,
    incrementPlayerOneComfortDaresAnswered,
    incrementPlayerTwoComfortTruthsAnswered,
    incrementPlayerTwoComfortLightDaresAnswered,
    incrementPlayerTwoComfortDaresAnswered,
    incrementPlayerOneComfortShotsTaken,
    incrementPlayerTwoComfortShotsTaken,
    toggleComfortPlayerTurn,

    
    incrementPlayerOneOpenTruthsAnswered,
    incrementPlayerOneOpenLightDaresAnswered,
    incrementPlayerOneOpenDaresAnswered,
    incrementPlayerOneOpenKinkyDaresAnswered,
    incrementPlayerTwoOpenTruthsAnswered,
    incrementPlayerTwoOpenLightDaresAnswered,
    incrementPlayerTwoOpenDaresAnswered,
    incrementPlayerTwoOpenKinkyDaresAnswered,
    incrementPlayerOneOpenShotsTaken,
    incrementPlayerTwoOpenShotsTaken,
    toggleOpenPlayerTurn,

    resetGame,
  } = contestantsSlice.actions;
  
  
  export default contestantsSlice.reducer;